<template>
  <div class="main text-left">
    <div class="form-group">
      <label class="text-muted small">スタッフが提示した6桁番号を入力してください
      </label>
      <input type="text" class="form-control form-control-sm" v-model="input.stampcode" :required="true" :maxlength="6">
    </div>
    <span class="btn btn-warning btn-sm" v-on:click="send()">確定</span>
  </div>
</template>
<script>
import sx from '../utils/core.js'

export default {
  data() {
    return {
      input: {
        stampcode: ''
      }
    }
  },
  created() {
    this.$store.state.title = '番号で入力'
    this.$store.state.showBack = true
    this.$store.state.pageBack = 'Stamp'
  },
  mounted() {
    this.$store.state.showBack = true
  },
  destroyed() {
    this.$store.state.showBack = false
  },
  methods: {
    send() {
      const that = this
      if (!sx.isNothingOrEmpty(that.input.stampcode)) {
        sx.showWaiting()
        var params = {
          corpid: 40,
          bucketid: '17',
          stampid: that.$store.state.stampid,
          stampcode: that.input.stampcode,
          token: localStorage.getItem('token')
        }
        var url = that.$store.state.baseurl + '/app/mshelper/addStampByCode'
        sx.request(
          url,
          params,
          function (result) {
            if (result.status === 'ok') {
              setTimeout(function () {
                that.sendmail = true
                sx.toastSuccess('スタンプを受け取りました！')
                that.$router.replace({ name: 'Stamp' })
              }, 1000);
            } else {
              sx.toastError(result.message)
            }
            sx.hideWaiting()
          },
          function (result) {
            sx.login(
              url,
              params,
              function (result) {
                if (result.status === 'ok') {
                  setTimeout(function () {
                    that.sendmail = true
                    sx.toastSuccess('スタンプを受け取りました！')
                    that.$router.replace({ name: 'Stamp' })
                  }, 1000);
                } else {
                  sx.toastError(result.message)
                }
              }
            )
            sx.hideWaiting()
          }
        )
        sx.hideWaiting()
      } else {
        sx.toastError('番号を入力してください！')
      }
    }
  }
}
</script>
<style scoped>
.main {
  padding: 20px;
}
</style>
